<template>
  <div style="position: sticky; top: 0; z-index: 2">
    <div class="install-btn" v-if="false">
      <!-- <img src="@/static/install_bg.svg" alt=""> -->
      <button class="install-btn-content" @click="installApp">
        <div>
          <img src="@/static/install_btn.png" alt="" />
          <p>{{ $t('install-btn') }}</p>
        </div>
      </button>
      <div class="close-btn"><img src="@/static/x.svg" alt="" /></div>
    </div>
    <SideBar :sideBarHeight="showInstallButton == true ? '60' : '110'" />
    <div class="top">
      <div class="top_in" :class="{ loggedin: userDetails }">
        <div class="top_in_right">
          <router-link to="/" style="line-height: 0">
            <img class="top_logo" :src="logo" alt="" />
          </router-link>
        </div>

        <!-- Top -->
        <div class="top_in_left">
          <img v-if="$route.path !== '/searchGames'" @click="searchGame()" src="../static/images/searchIcon.png" class="" style="max-width: 25px; margin-right: 1.5rem;"/>
          <!-- <div class="login_and_register" v-if="userInfo.name == ''">
            <button class="login" @click="showLoginModal()">
              {{ $t('登录') }}
            </button>
            <button class="register" @click="showRegisterModal()">
              {{ $t('注册') }}
            </button>
          </div>

          <div class="after_login" v-if="userInfo.name != ''">
            <div style="display: flex; align-items: center; gap: 0.5rem">
              <div>
                  <div class="profile" style="font-family: 700; color: #000000;" :key="userInfo.name">{{ userInfo.name }}</div>
                    <div class="money" style="display: flex; align-items: center; gap: 2px; background: #7B96B7; border-radius: 15px; padding: 2px 10px 2px 7px; margin-right: -2rem; font-weight: 600; color: #FFFFFF;">
                      <img src="@/static/images/brazilLogo.png" alt="" height="20px" /> R$ {{ userInfo.money }}
                    </div>
                  </div>
                <img
                  v-if="userProfilePhoto"
                  class="user_money"
                  height="60px" 
                  width="60px"
                  :src="userProfilePhoto"
                />
                <img
                  v-else
                  class="user_money"
                  src="@/static/images/header/user-icon.png"
                />
            </div>

            <div class="dropdown">
              <div v-if="dropdownOpen" class="dropdown-content">
                <a @click="userPopParam('存款')">{{ $t('存款') }}</a>
                <a @click="userPopParam('取款')">{{ $t('提现') }}</a>
                <a v-show="userDetails" @click="userPopParam('游戏记录')">
                  {{ $t('游戏记录') }}
                </a>
                <a v-show="userDetails" @click="userPopParam('交易记录')">
                  {{ $t('交易记录') }}
                </a>
                <div class="dropdown-divider-container">
                  <hr />
                </div>
                <a class="logout-container" @click="logout()">
                  {{ $t('Logout') }}
                  <img src="@/static/images/header/logout-btn.svg" class="" />
                </a>
              </div>
            </div>

            <div
              ref="usermenu"
              class="user_menu"
              style="display: none; transform: all 0.5s"
            >
              <ul>
                <li @click="userPopParam('存款')">{{ $t('充值') }}</li>
                <li @click="userPopParam('取款')">{{ $t('取款') }}</li>
                <li @click="userPopParam('游戏记录')">
                  {{ $t('游戏记录') }}
                </li>
                <li @click="userPopParam('交易记录')">
                  {{ $t('交易记录') }}
                </li>
              </ul>
            </div>
          </div> -->
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SideBar from '../components/sideBar.vue'

export default {
  props: ['userDetails', 'logo', 'showMoney'],
  components: {
    SideBar,
  },
  data: () => ({
    dropdownOpen: false,
    deferredPrompt: null,
    showInstallButton: false,
  }),
  computed: {
    ...mapState({
      language: (state) => state.lang.languageList,
      userInfo: (state) => state.auth.userInfo,
      userProfilePhoto: (state) => state.auth.userProfilePhoto,
    }),
  },
  methods: {
    searchGame() {
      this.$router.push('searchGames')
    },
    routeTo(val) {
      this.$router.push({ path: val })
    },
    logout() {
      sessionStorage.clear()
      location.reload()
    },
    userPopParam(item) {
      this.$refs.usermenu.style.display = 'none'
      this.userPopTitle = item
      this.userPopShow = true
    },
    showLoginModal() {
      console.log('HELLO')

      this.$store.commit('setLoginModalStatus', true)
    },
    showRegisterModal() {
      this.$store.commit('setRegisterModalStatus', true)
    },
    selectLangShow(item) {
      this.$store.dispatch('setLanguage', item)

      this.$i18n.locale = item.value
      location.reload()
    },
    selectLanguage() {
      if (this.$refs.selectlang.style.display == 'none') {
        this.$refs.selectlang.style.display = 'block'
        // this.$refs.langicon.className = "el-icon-arrow-up";
      } else {
        this.$refs.selectlang.style.display = 'none'
        // this.$refs.langicon.className = "el-icon-arrow-down";
      }
    },
    toggleDropdown() {
      if (!this.dropdownOpen) return (this.dropdownOpen = true)
      if (this.dropdownOpen) return (this.dropdownOpen = false)
    },
    installApp() {
      if (this.deferredPrompt.value) {
        this.deferredPrompt.value.prompt()
        this.deferredPrompt.value.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt')
          } else {
            console.log('User dismissed the A2HS prompt')
          }
          this.deferredPrompt.value = null // Clear the prompt
          showInstallButton.value = false // Hide the button after the prompt
        })
      }
    },
    closeInstall() {
      this.showInstallButton = false
    },
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.deferredPrompt = e
      this.showInstallButton = true
      console.log('beforeinstallprompt event fired')
    })
  },
  created() {
    this.$store.dispatch('getUserInfo')
    this.$store.dispatch('getLanguageList')
  },
}
</script>

<style lang="less" scoped>
.install-btn {
  background: url('../static/install_bg.svg');
  position: relative;
  right: 50%;
  transform: translateX(50%);
  height: 10vh;
  width: 100%;
  max-width: inherit;
  transform: translateX(50%);
  background-color: #333;
  color: #fff;
  border-radius: 0 0 5px 5px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;

  .install-btn-content {
    // position: absolute;
    // left: 5%;
    // top: 50%;
    // transform: translate(0%, -50%);
    background: transparent;
    border: none;

    div {
      position: relative;

      img {
        width: 130px;
        height: 40px;
      }
      p {
        font-family: 'Insaniburger';
        font-size: 20px;
        line-height: 30px;
        position: absolute;
        width: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
      }
    }
  }
  .close-btn {
    img {
      width: 30px;
      height: 30px;
      cursor: pointer;

      &:hover {
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
      }
      &:active {
        background-color: rgba(0, 0, 0, 0.75);
      }
    }
  }
}

.top {
  top: 0;
  width: 100%;
  background: #1A2C38;
  box-shadow: 0px 4px 5.8px 0px #00000040;
  height: auto;
  z-index: 2;
  position: sticky;
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;

  .top_in,
  .warp {
    width: 100% !important;
  }

  .top_in {
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: 14.4px 8.5px;

    &.loggedin {
      .language .selectLang {
        top: 55px;
      }
    }

    .top_in_right {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 38%;

      .top_logo {
        cursor: pointer;
        max-height: 66px;
        max-width: 150px;
        @media (max-width: 515px) {
          width: 90px;
        }
      }
    }

    .top_in_left,
    .login_and_register {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-content: center;
      align-items: center;
      gap: 0.7rem;
    }

    .login_and_register {
      align-items: center;
      margin-right: 5px;
      position: static;
      top: 130px;
      left: 17%;
      z-index: 2;

      button {
        font-family: 'Insaniburger';
        font-size: 20px;
        line-height: 30px;
        cursor: pointer;
        text-align: center;
        border: none;
        letter-spacing: 0.5px;
        background-color: transparent;

        &.login {
          background: linear-gradient(180deg, #08B9F7 50%, #0377EF 136.67%);
          border-radius: 20px;
          padding: 8px 30px;
          color: #fff;
        }

        &.register {
          background: linear-gradient(180deg, #F27B63 0%, #FF5478 160%);
          border-radius: 20px;
          padding: 8px 30px;
          color: #fff;
        }

        &:hover {
          opacity: 0.9;
        }

        i.icon {
          margin-right: 5px;
          top: 3px;
          position: relative;
        }

        img.icons {
          margin-right: 5px;
          top: 3px;
          position: relative;
        }
      }
    }

    .user-icon {
      margin-right: 5px;
      position: relative;
    }

    .user-icon-image {
      height: 14px;
      width: 15px;
      margin-right: 5px;
      color: #fff;
    }

    .language {
      position: relative;
      display: flex;

      .select_lang {
        display: flex !important;
        width: 30px;
        box-sizing: content-box;
        align-items: center;
        justify-content: center;
        color: #343743;
        font-size: 13px;
        cursor: pointer;
        height: 100%;
        width: 100%;

        img {
          height: 45px;
        }

        .imgLangContainer {
          display: block !important;
        }

        i {
          color: #64b000;
          font-weight: 800;
          font-size: 18px;
          margin-left: 5px;
        }

        img.icon {
          margin-right: 5px;
        }
      }

      .selectLang {
        position: absolute;
        top: 35px;
        right: -10px;
        padding: 5px 0;
        background: #24221a;
        z-index: 1000;
        border-radius: 10px;
        border: 1px solid #555;

        .lang_one {
          position: relative;
          cursor: pointer;
          text-align: center;
          line-height: 30px;
          font-size: 13px;
          color: #fff;
          display: flex;
          flex-direction: column;
          gap: 50px;
          z-index: 9;
          padding: 5px 10px;

          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }

    .after_login {
      display: flex;
      align-items: center;
      height: auto;
      flex-wrap: wrap;
      justify-content: center;

      .logout {
        background-color: #feb805;
      }
    }

    .user {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 40px;
      width: 130.35px;
      text-align: center;
      position: relative;
      cursor: pointer;
      border-radius: 10px;
      background: linear-gradient(180deg, #44c1e9 100%, #0a8bfd 100%);
      border-radius: 0px 5px 5px 0px;
      border: none;

      .user_text {
        font-family: 'Saira', sans-serif;
        color: #030614;
        display: flex;
        align-items: center;
        font-size: 13px;
        font-weight: 400;

        img {
          margin-right: 5px;
        }

        i {
          margin-right: 5px;
        }
      }

      &_menu {
        position: absolute;
        top: 62px;
        left: 0;
        z-index: 9999;
        background: #1e2024;
        color: #fff;

        li {
          height: 30px;
          width: 240px;
          list-style: none;
          text-align: start;
          padding-left: 20px;
          padding-top: 5px;
          box-sizing: border-box;
        }

        li:hover {
          background-color: rgba(255, 255, 255, 0.1);
          color: #fff;
        }
      }
    }
  }
}

.dropdown-content {
  opacity: 1;
  top: 35px;
  display: block;
  position: absolute;
  right: -10px;
  background: #2f2e2d;
  min-width: 230px;
  z-index: 999;
}

.dropdown-content a {
  cursor: pointer;
  color: #fff;
  padding: 12px 20px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background: #45c1e9;
  color: #fff;
}

.user_money-lang {
  color: #598393;
  text-align: center;
  font-family: 'Saira', sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.user_money {
  z-index: 1;

  &.profile {
    height: 60px;
    width: 60px;
  }
}

.user_info {
  margin: 0;
  padding: 0px 0px;
  border-radius: 5px;

  .u_i_left {
    display: flex !important;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    width: 100%;

    .rechargeBtn {
      &:active {
        height: 110%;
        width: 110%;
        margin-left: -10px;
      }
      margin-left: -15px;
    }

    i {
      width: 25px;
      height: 25px;
      margin-top: 7px;
      margin-right: -10px;
    }
  }

  .u_i_right {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #fff;

    div {
      font-family: 'AvertaStd-Regular';
      font-size: 14px;
      line-height: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      background-color: #101e3b;
      border-radius: 0 50px 0px 0;
      padding: 3px 25px 3px 40px;
      margin-left: -35px;

      @media screen and (max-width: 375px) {
        width: 100px;
      }

      .profile {
        text-align: end;
        padding-right: 10px;
      }

      &.money {
        display: flex;
        align-items: center;
        // justify-content: center;
        text-align: center;
        color: #ddd;
        border-radius: 0 0px 50px 0;
        background: #02021a;
        gap: 5px;
        font-weight: 700;
      }
    }

    .vip {
      font-family: 'Saira', sans-serif;
      font-weight: 400;
      color: #c5c5c5;
      text-transform: uppercase;
    }
  }
}

.dropdown {
  user-select: none;
  position: relative;
  display: inline-block;
}

.dropdown-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0b1030;
  color: white;
  padding: 22px 10px;
  border-radius: 10px;
  cursor: pointer;
}

.dropdown-button:hover,
.dropdown-button:focus {
  background-color: #0e1541;
}

.dropdown-content {
  opacity: 1;
  top: 35px;
  display: block;
  position: absolute;
  right: -10px;
  background: #2f2e2d;
  min-width: 230px;
  z-index: 999;
}

.dropdown-content a {
  cursor: pointer;
  color: #fff;
  padding: 12px 20px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background: #45c1e9;
  color: #fff;
}

.dropdown-divider-container {
  display: flex;
  justify-content: center;
  align-items: center;

  hr {
    width: 100%;
    background-color: #fff;
    height: 1px;
    border: none;
  }
}

.logout-container {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}

.deposit-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  color: white;
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  background: linear-gradient(180deg, #83D1FF -66.25%, #2B62EB 79.25%, #418DFF 176.25%);
  position: relative;
  cursor: pointer;
  border-radius: 5px;
}

.deposit-button p {
  margin: 0;
  padding: 0;
}

.deposit-button img {
  margin-left: 10px;
  display: flex;
  justify-content: center;
}

// .deposit-button::before {
//   content: '';
//   position: absolute;
//   height: 80%;
//   width: 1px;
//   background-color: #333;
//   top: 8%;
//   right: 45px;
// }

@media (max-width: 515px) {
  .depositBtn {
    img {
      width: -webkit-fill-available !important;
    }
  }

  .customer-service,
  .backtotop {
    right: 10px;
  }

  .top .top_in .top_in_right .top_logo {
    max-height: 50px;
  }

  .top .top_in .login_and_register button {
    padding: 8px 18px !important;
    font-size: 16px;
    line-height: 26px;
  }

  .imgModal img {
    max-width: 80%;
  }
}

@media (max-width: 425px) {
  .top .top_in {
    // padding: 4px;

    .login_and_register button {
      padding: 4px 14px !important;
      font-size: 14px;
      line-height: 24px;
    }
  }
  .after_login {
  }
  .top .top_in .language .select_lang img {
    height: 35px;
  }
  .u_i_left {
    .user_money {
      height: 25%;
      width: 25%;
    }
    .rechargeBtn {
      margin-left: -10px !important;
      height: 100%;
      width: 100%;
    }
  }
  .user_info .u_i_right div {
    font-size: 12px;
    line-height: 18px;
    padding: 2px 15px 2px 40px;

    .user_money {
      width: 30%;
      height: 30%;
    }
  }
}

@media (max-width: 375px) {
  .top .top_in {
    padding: 4px;

    .login_and_register button {
      padding: 4px 14px !important;
      font-size: 14px;
      line-height: 24px;
    }
  }
  .after_login {
  }
  .top .top_in .language .select_lang img {
    height: 35px;
  }
  .u_i_left {
    .user_money {
      height: 35%;
      width: 35%;
    }
    .rechargeBtn {
      margin-left: -10px !important;
      height: 100%;
      width: 100%;
    }
  }
  .user_info .u_i_right div {
    font-size: 12px;
    line-height: 18px;
    padding: 2px 10px 2px 35px;

    .user_money {
      width: 30%;
      height: 30%;
    }
  }
}

@media (max-width: 350px) {
  .top .top_in {
    .login_and_register button {
      padding: 4px 12px !important;
      font-size: 12px;
      line-height: 22px;
    }

    .language .select_lang img {
      height: 32px;
    }

    .top_in_right .top_logo {
      max-height: 40px;
    }
  }
}

@media (max-width: 325px) {
  .top .top_in {
    .login_and_register button {
      padding: 4px 10px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topBar.vue